export const colors = {
  yellow: "#fceabd",
  pink: "#faf3f0",
  pinkLight: "#faf8f7",
  black: "#121010",
};
